import managerReducer from "./managerSlice";

export default managerReducer;
